module.exports = __webpack_public_path__ + "img/arrow.0390e83b.svg";